// Full-document render of the tempurpedic TempurLoveSocialPage: PageSkeleton
// (the React document shell) wrapping the hub header (rendered only when the
// page sits under a TempurLoveRootPage, like the legacy partial's
// {% if love_root %}) and the existing social-gallery body island.
import React from "react";

import { templates } from "@reactivated";

import { TempurLoveSocialPage as TempurLoveSocialPageBody } from "../apps/tempur-love/TempurLoveSocialPage";
import { PageSkeleton } from "../components/PageSkeleton";
import { TempurLoveHeader } from "../components/TempurLoveHeader";

// Mutable reactivated props (not Immutable<>): this template composes the
// in-tree SiteHeader chain via PageSkeleton, which is typed with mutable
// reactivated props (see PageSkeleton).
type IProps = templates.TempurLoveSocialPageDocumentTemplate;

export const Template = (props: IProps): React.JSX.Element => {
    return (
        <PageSkeleton pageChrome={props.page_chrome}>
            {props.love_root && (
                <TempurLoveHeader love_root={props.love_root} />
            )}
            <TempurLoveSocialPageBody
                page_info={props.page_info}
                love_root_info={props.love_root_info}
                initial_ugc_data={props.initial_ugc_data}
                initial_next_url={props.initial_next_url}
            />
        </PageSkeleton>
    );
};
